import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CategoryIcon } from "@/components/CategoryIconPicker";
import { API, fmtMoney } from "@/lib/api";
import { Search, ListOrdered, RotateCcw, LayoutGrid } from "lucide-react";

export default function ProductPickerPanel({ mobilePanel, kind, isEdit, nav, searchTerm, setSearchTerm, categories, activeCat, setActiveCat, catCounts, filteredProducts, addLine }) {
  return (
      <div className={`${mobilePanel === "products" ? "flex" : "hidden"} lg:flex lg:col-span-7 min-h-[560px] lg:min-h-0 border border-border rounded-xl bg-card flex-col shadow-sm`}>
        <div className="p-4 border-b border-border space-y-3 bg-muted/20">
          <div className="flex items-center gap-2">
            <div className="relative flex-1">
              <Search className="absolute start-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <Input placeholder="بحث سريع في الأصناف..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} className="ps-9 h-12 text-base" data-testid="product-search-input" />
            </div>
            {kind === "sale" && !isEdit && (
              <>
                <Button size="sm" variant="outline" onClick={()=>nav("/invoices")} className="gap-1" data-testid="jump-invoices-btn" title="سجل الفواتير">
                  <ListOrdered className="w-4 h-4" /><span className="hidden md:inline">الفواتير</span>
                </Button>
                <Button size="sm" variant="outline" onClick={()=>nav("/invoices")} className="gap-1 text-amber-700 border-amber-300" data-testid="jump-returns-btn" title="مرتجعات المبيعات">
                  <RotateCcw className="w-4 h-4" /><span className="hidden md:inline">مرتجع</span>
                </Button>
              </>
            )}
          </div>
          {/* Category tabs — Al-Ameen-style */}
          <div className="flex items-center gap-1.5 overflow-x-auto pb-1" data-testid="category-tabs">
            <button onClick={()=>setActiveCat("all")} className={`shrink-0 px-3 py-1.5 rounded-md text-xs font-bold border transition-all ${activeCat === "all" ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border hover:border-primary"}`} data-testid="cat-tab-all">
              <LayoutGrid className="w-3 h-3 inline me-1" /> الكل <span className="opacity-70">({catCounts.all || 0})</span>
            </button>
            {categories.map(c => (
              <button key={c.id} onClick={()=>setActiveCat(c.name)} className={`shrink-0 px-3 py-1.5 rounded-md text-xs font-bold border transition-all inline-flex items-center gap-1 ${activeCat === c.name ? "text-white border-transparent" : "bg-card border-border hover:border-primary"}`}
                style={activeCat === c.name ? {background: c.color || "#3B82F6"} : {color: c.color || "#3B82F6"}}
                data-testid={`cat-tab-${c.id}`}>
                <CategoryIcon name={c.icon || "Package"} size={13} />
                <span className={activeCat === c.name ? "text-white" : "text-foreground"}>{c.name}</span>
                <span className="opacity-70">({catCounts[c.name] || 0})</span>
              </button>
            ))}
            {catCounts[""] > 0 && (
              <button onClick={()=>setActiveCat("")} className={`shrink-0 px-3 py-1.5 rounded-md text-xs font-bold border transition-all ${activeCat === "" ? "bg-slate-600 text-white border-slate-600" : "bg-card border-border hover:border-primary"}`} data-testid="cat-tab-none">
                بدون تصنيف <span className="opacity-70">({catCounts[""] || 0})</span>
              </button>
            )}
          </div>
        </div>
        <div className="flex-1 overflow-auto p-3">
          <div className="grid grid-cols-1 min-[420px]:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {filteredProducts.map(p => {
              const catColor = categories.find(c => c.name === p.category)?.color;
              return (
                <button key={p.id} onClick={()=>addLine(p)} data-testid={`product-card-${p.id}`}
                  className="text-start border border-border rounded-xl p-4 bg-card hover:border-primary hover:bg-accent transition-colors hover-lift relative overflow-hidden min-h-[142px]">
                  {catColor && <span className="absolute top-0 end-0 w-2 h-full" style={{background: catColor}} />}
                  {p.image_url && (
                    <img src={`${API}${p.image_url}`} alt="" className="w-full h-20 object-cover rounded-lg mb-3" onError={(e)=>{e.target.style.display='none'}} />
                  )}
                  <div className="font-bold text-base leading-snug break-words min-h-[2.75rem]">{p.name}</div>
                  {p.category && <div className="text-xs text-muted-foreground mt-1 truncate">{p.category}</div>}
                  <div className="text-xs text-muted-foreground mt-2">رصيد: <span className="tabular-nums">{p.stock}</span></div>
                  <div className="mt-2 text-primary font-bold tabular-nums text-base">{fmtMoney(kind==="sale"?p.sale_price:p.cost_price, p.currency)}</div>
                </button>
              );
            })}
            {filteredProducts.length === 0 && <div className="col-span-full text-center text-muted-foreground py-8 text-sm">لا توجد أصناف {activeCat !== "all" ? `في «${activeCat || "بدون تصنيف"}»` : ""}</div>}
          </div>
        </div>
      </div>

  );
}
